export default __webpack_public_path__ + "static/media/ecommercepic.da4bdc7f.png";